import { Box, BoxProps } from '@mui/material';

function Well(props: BoxProps) {
  return (
    <Box bgcolor="secondary.light" borderRadius="4px" padding={2} {...props} />
  );
}

export default Well;
